import './App.css';
import { useState } from 'react';


function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="App">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <h1 className="logo"><img src="/assets/a2b-logo.png" alt="A2B Catering" /></h1>
          <div className="nav-content">
            <div className={`nav-links ${isMenuOpen ? 'nav-links-open' : ''}`}>
              
              <a href="#home" onClick={(e) => { e.preventDefault(); document.getElementById('home').scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }}> Home</a>
              <a href="#about" onClick={(e) => { e.preventDefault(); document.getElementById('about').scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }}> About</a>
              <a href="#cuisine" onClick={(e) => { e.preventDefault(); document.getElementById('cuisine').scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }}> Cuisine</a>
              <a href="#services" onClick={(e) => { e.preventDefault(); document.getElementById('services').scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }}> Services</a>
              <a href="#features" onClick={(e) => { e.preventDefault(); document.getElementById('features').scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }}> Features</a>
              <button className="mobile-cta-button" onClick={() => { document.getElementById('contact').scrollIntoView({ behavior: 'smooth' }); setIsMenuOpen(false); }}>
                <i className="fas fa-phone"></i>
                Request A Call
              </button>
            </div>
            <button className="nav-cta-button" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
              <i className="fas fa-phone"></i>
              Request A Call
            </button>
            <button className="mobile-menu-toggle" onClick={toggleMenu}>
              <span className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}></span>
              <span className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}></span>
              <span className={`hamburger ${isMenuOpen ? 'hamburger-open' : ''}`}></span>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-video">
          <video autoPlay muted loop playsInline>
            <source src="https://storage.googleapis.com/mhp-media/video/A2B%20CATERING%20SERVICES.mp4" type="video/mp4" />
            <source src="https://storage.googleapis.com/mhp-media/video/A2B%20CATERING%20SERVICES.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="hero-overlay"></div>
        </div>
        
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="about-container">
          <div className="about-image">
            <img src="/assets/banner-1.jpg" alt="Professional catering service" />
          </div>
          <div className="about-content">
            <h2 className="about-title">Tradition Served Fresh</h2>
            <div className="about-badge">Authentic South Indian Vegetarian Catering in the USA
            </div>
            {/* <h2 className="about-title">Welcome To The Best Catering Company</h2> */}
            <p className="about-description">
              
            </p>
            {/* <h3 className="about-subtitle">20 Years Experience In This Business</h3> */}
            <p className="about-description">
              A2B Catering brings the authentic taste of South Indian vegetarian cuisine to events across the USA. From weddings, birthdays, and festive celebrations to small gatherings, we create memorable and joyous dining experiences with unmatched care, passion, and tradition.
              Our expert chefs craft delicious vegetarian dishes with strict attention to hygiene and quality. With high-class supervision in the kitchen, every plate reflects flavor, elegance, and trusted service.
              With A2B Catering, every meal is prepared with love and care, ensuring a memorable dining experience for your special occasions.
              A2B Catering is not just a catering service; it's a celebration of culture, tradition, and the joy of sharing delicious food with loved ones.
            </p>
          </div>
        </div>
      </section>

      {/* Cuisine Section */}
      <section id="cuisine" className="cuisine-hero">
        <div className="cuisine-overlay">
          <div className="cuisine-content">
            <h1 className="cuisine-title">
            A2B’s Dedicated Catering Experience
              
           
            </h1>
            <p className="cuisine-description">
            With years of expertise, A2B Catering has successfully served countless weddings, corporate gatherings, community festivals, and private parties across the US. We bring authentic flavors, professional service, and memorable dining experiences to every event we cater.
            </p>
            <button className="cuisine-cta-button" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
              REQUEST A PROPOSAL
            </button>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <h3 className="section-title">We Cater To</h3>
        
          
          <div className="services-categories">
            <div className="service-category">
             
              <div className="services-grid">
                <div className="service-item">
                  <h5>Backyard Parties</h5>
                  <p>Casual outdoor celebrations with fresh, seasonal menus perfect for your backyard gathering.</p>
                    <button className="learn-more-btn" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
                      <i className="fas fa-arrow-right"></i> Learn More
                    </button>
                </div>
                <div className="service-item">
                  <h5>Live Counters</h5>
                  <p>Interactive cooking stations where our chefs prepare dishes live, creating an engaging dining experience.</p>
                    <button className="learn-more-btn" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
                      <i className="fas fa-arrow-right"></i> Learn More
                    </button>
                </div>
                <div className="service-item">
                  <h5>Wedding Catering</h5>
                  <p>Elegant wedding receptions with custom menus and flawless execution for your special day.</p>
                    <button className="learn-more-btn" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
                      <i className="fas fa-arrow-right"></i> Learn More
                    </button>
                </div>
                <div className="service-item">
                  <h5>Birthday Celebrations</h5>
                  <p>Memorable birthday parties with personalized menus and festive presentation for all ages.</p>
                    <button className="learn-more-btn" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
                      <i className="fas fa-arrow-right"></i> Learn More
                    </button>
                </div>
              
                <div className="service-item">
                  <h5>Corporate Events</h5>
                  <p>Professional catering for business meetings, conferences, and corporate celebrations.</p>
                    <button className="learn-more-btn" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
                      <i className="fas fa-arrow-right"></i> Learn More
                    </button>
                </div>
                <div className="service-item">
                  <h5>Private Parties</h5>
                  <p>Intimate celebrations and milestone events with personalized culinary experiences.</p>
                    <button className="learn-more-btn" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
                      <i className="fas fa-arrow-right"></i> Learn More
                    </button>
                </div>
                
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features">
        <div className="container">
          <h3 className="section-title">Why Choose A2B Catering?</h3>
          <div className="features-intro">
            <p>Experience the difference with our premium features designed to make your event planning seamless and memorable.</p>
          </div>
          
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-utensils"></i>
              </div>
              <h4>Customizable Menus</h4>
              <p>Customize your menu or meal boxes with a diverse selection of dishes tailored to your preferences and dietary requirements.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h4>Dynamic Pricing</h4>
              <p>Price per plate decreases as the number of guests increases, ensuring better value for larger events and celebrations.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-user-tie"></i>
              </div>
              <h4>Personal Order Executive</h4>
              <p>A single point of contact for all your order details, ensuring personalized service and dedicated attention to your needs.</p>
            </div>
           
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h3 className="section-title">Get In Touch</h3>
          <div className="contact-intro">
            <p>Ready to create an unforgettable culinary experience? Let's discuss your event and bring your vision to life.</p>
          </div>
          
          <div className="contact-content">
            <div className="contact-form-section">
              <div className="contact-form-header">
                <h4>Send Us a Message</h4>
                <p>Fill out the form below and we'll get back to you within 24 hours.</p>
              </div>
              
              <form className="contact-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">First Name *</label>
                    <input type="text" id="firstName" name="firstName" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName">Last Name *</label>
                    <input type="text" id="lastName" name="lastName" required />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input type="email" id="email" name="email" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number *</label>
                    <input type="tel" id="phone" name="phone" required />
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="eventType">Event Type *</label>
                    <select id="eventType" name="eventType" required>
                      <option value="">Select Event Type</option>
                      <option value="wedding">Wedding</option>
                      <option value="corporate">Corporate Event</option>
                      <option value="birthday">Birthday Party</option>
                      <option value="family">Family Gathering</option>
                      <option value="backyard">Backyard Party</option>
                      <option value="private">Private Party</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="guestCount">Number of Guests *</label>
                    <select id="guestCount" name="guestCount" required>
                      <option value="">Select Guest Count</option>
                      <option value="1-25">1-25 guests</option>
                      <option value="26-50">26-50 guests</option>
                      <option value="51-100">51-100 guests</option>
                      <option value="101-200">101-200 guests</option>
                      <option value="200+">200+ guests</option>
                    </select>
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="eventDate">Event Date *</label>
                    <input type="date" id="eventDate" name="eventDate" required />
                  </div>
                  <div className="form-group">
                    <label htmlFor="eventTime">Event Time</label>
                    <input type="time" id="eventTime" name="eventTime" />
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="eventLocation">Event Location</label>
                  <input type="text" id="eventLocation" name="eventLocation" placeholder="Venue name or address" />
                </div>
                
               
                
               
                
               
                
                <button type="submit" className="submit-btn">
                  <span>Send Message</span>
                  <i className="fas fa-paper-plane btn-icon"></i>
                </button>
              </form>
            </div>
            
            <div className="contact-info-section">
              <div className="contact-info">
                <h4>Contact Information</h4>
                <div className="contact-item">
                  <div className="contact-icon"><i className="fas fa-phone"></i></div>
                  <div className="contact-details">
                    <strong>Phone</strong>
                    <p>+1 (732) 971-1500</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon"><i className="fas fa-envelope"></i></div>
                  <div className="contact-details">
                    <strong>Email</strong>
                    <p>info@a2bcatering.com</p>
                  </div>
                </div>
                
               
                
                <div className="contact-item">
                  <div className="contact-icon"><i className="fas fa-clock"></i></div>
                  <div className="contact-details">
                    <strong>Business Hours</strong>
                    <p>Mon-Fri: 8:00 AM - 6:00 PM</p>
                    <p>Sat: 9:00 AM - 4:00 PM</p>
                    <p>Sun: By Appointment</p>
                  </div>
                </div>
              </div>
              
              <div className="map-container">
                <h4>Find Us</h4>
                <div className="map-placeholder">
                  <div className="map-content">
                    <div className="map-icon"><i className="fas fa-map"></i></div>
                    <p>Interactive Map</p>
                    <small>28244 Diehl Rd, Warrenville, IL 60555</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/assets/a2b-logo.png" alt="A2B Catering" />
                <h3>A2B Catering</h3>
              </div>
              <p>Authentic South Indian Vegetarian Catering in the USA. Bringing tradition to your table with fresh, flavorful dishes for every occasion.</p>
              <div className="social-links">
                <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
                <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
                <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
                <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
              </div>
            </div>
            
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><a href="#home" onClick={(e) => { e.preventDefault(); document.getElementById('home').scrollIntoView({ behavior: 'smooth' }); }}><i className="fas fa-home"></i> Home</a></li>
                <li><a href="#about" onClick={(e) => { e.preventDefault(); document.getElementById('about').scrollIntoView({ behavior: 'smooth' }); }}><i className="fas fa-info-circle"></i> About</a></li>
                <li><a href="#cuisine" onClick={(e) => { e.preventDefault(); document.getElementById('cuisine').scrollIntoView({ behavior: 'smooth' }); }}><i className="fas fa-utensils"></i> Cuisine</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); document.getElementById('services').scrollIntoView({ behavior: 'smooth' }); }}><i className="fas fa-utensils"></i> Services</a></li>
                <li><a href="#features" onClick={(e) => { e.preventDefault(); document.getElementById('features').scrollIntoView({ behavior: 'smooth' }); }}><i className="fas fa-star"></i> Features</a></li>
                <li><a href="#contact" onClick={(e) => { e.preventDefault(); document.getElementById('contact').scrollIntoView({ behavior: 'smooth' }); }}><i className="fas fa-envelope"></i> Contact</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Services</h4>
              <ul>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); document.getElementById('services').scrollIntoView({ behavior: 'smooth' }); }}>Wedding Catering</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); document.getElementById('services').scrollIntoView({ behavior: 'smooth' }); }}>Corporate Events</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); document.getElementById('services').scrollIntoView({ behavior: 'smooth' }); }}>Birthday Parties</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); document.getElementById('services').scrollIntoView({ behavior: 'smooth' }); }}>Family Gatherings</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); document.getElementById('services').scrollIntoView({ behavior: 'smooth' }); }}>Backyard Parties</a></li>
                <li><a href="#services" onClick={(e) => { e.preventDefault(); document.getElementById('services').scrollIntoView({ behavior: 'smooth' }); }}>Live Counters</a></li>
              </ul>
            </div>
            
            <div className="footer-section">
              <h4>Contact Info</h4>
              <div className="contact-info1">
                <div className="contact-item">
                  <i className="fas fa-phone"></i>
                  <span>+1 (732) 971-1500</span>
                </div>
                <div className="contact-item">
                  <i className="fas fa-envelope"></i>
                  <span>info@a2bcatering.com</span>
                </div>
               
                
              </div>
            </div>
            
          </div>
          
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <p>&copy; 2025 A2B Catering. All rights reserved.</p>
              <div className="footer-bottom-links">
                <a href="#">Privacy Policy</a>
                <a href="#">Terms of Service</a>
                <a href="#">Cookie Policy</a>
              </div>
            </div>
            <div className="powered-by">
              <span>Powered by</span>
              <img src="/assets/maghil.png" alt="Maghil" />
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
